import {
  CourseHomepageContainer,
  CourseHomeRight,
  CouseHomeLeft,
  TakeQuizButton,
} from './CourseHome.styles';
import { useParams } from 'react-router-dom';
import React, { Suspense } from 'react';
import CourseDataProvider from '../../Utils/Courses/CourseDataProvider';
import NotFound from '../../Routes/MainComponents/not-found/NotFoundPage.component';
import { AuthCheckUser } from '../../Utils/AuthCheck/UserCheck.auth';
import CourseSideMenu from './CourseHomeSideMenu.component';
import CourseDataDisplayed from './CourseData.component';
import HelmetHelper from '../../Components/PageHelmet/HelmetHelper.component';
import CourseLoadingPage from '../../Components/LoadingPages/LoadingCourse.component';
import QuizButton from './TakeQuizButton.component';
// Taking the course the homepage that displays the presentation, documentation and video links
const CourseHomepage = () => {
  const { id } = useParams();
  if (!id) {
    return <NotFound />;
  }

  return (
    <Suspense fallback={<CourseLoadingPage />}>
      <AuthCheckUser>
        <HelmetHelper
          title="Course Homepage"
          description="Course homepage, take the presentation, review videos and documentation"
        />
        <CourseDataProvider courseId={id} loadingComponent={CourseLoadingPage}>
          {(course) => (
            <>
              <CourseHomepageContainer>
                <CourseHomeRight>
                  <CourseSideMenu
                    course={course}
                    status="Course is currently incomplete"
                  />
                  <QuizButton id={id} />
                </CourseHomeRight>
                <CouseHomeLeft>
                  {!course?.courseName ? (
                    <>
                      <NotFound />
                    </>
                  ) : (
                    <>
                      <CourseDataDisplayed data={course} />
                      <TakeQuizButton>
                        <QuizButton id={id} />
                      </TakeQuizButton>
                    </>
                  )}
                </CouseHomeLeft>
              </CourseHomepageContainer>
            </>
          )}
        </CourseDataProvider>
      </AuthCheckUser>
    </Suspense>
  );
};
export default CourseHomepage;
